import {CardShopStruct} from "../structs/CardShopStruct";

export class CardShopRepository {

    static getAll() {
        return JSON.parse(localStorage.getItem("card_shop"));
    }

    static getItem(id) {
        if (this.getAll()===null) return false

        let find;
        this.getAll().forEach(function (item) {
            if (item.product.id === id) {
                find= item
            }
        })

        if (find)return find

        return false
    }

    static deleteAll() {
        return localStorage.removeItem("card_shop")
    }

    static addCardShop(productItem) {
        let list = this.getAll()

        if (list === null)
            list = [];

        let check = false;
        list.forEach(function (item) {
            if (item.product.id === productItem.id) {
                item.count++
                check = true
            }
        })

        if (check) {
            localStorage.setItem("card_shop", JSON.stringify(list))
        }else {
            let cardShopStruct = new CardShopStruct()
            cardShopStruct.product = productItem
            cardShopStruct.count++

            list.push(cardShopStruct)


            localStorage.setItem("card_shop", JSON.stringify(list))
        }

    }

    static decreaseCardShop(productItem) {
        let list = this.getAll()

        if (list === null)
            return

        list.forEach(function (item,i) {
            console.log(list)
            if (item.product.id === productItem.id) {

                if (item.count > 1) {
                    item.count--
                } else {
                    list.splice(i,1)
                }
            }
        })

        localStorage.setItem("card_shop", JSON.stringify(list))

    }
}
